var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:{ 'large-box': _vm.isLarge, editing: _vm.isEditing, sticky: _vm.isSticky },style:({
    height: _vm.checkoutHeight ? `${_vm.checkoutHeight}px` : null,
    'border-radius': _vm.checkoutHeight ? '0.25rem 0.25rem 0 0' : null,
    'z-index': _vm.zIndex ? '10' : '1',
  })},[_c('div',{staticClass:"box-content"},[_c('div',{staticClass:"box-header"},[_c('p',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("action")],2),_vm._t("default")],2),_vm._t("button"),_c('transition',{attrs:{"name":"opacity"}},[(_vm.isLoading)?_c('div',{staticClass:"component-loading"},[_c('Loading')],1):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }